/**
 * Truck Guy Upfitters — Vehicle Master Dataset & Fitment Matrix (1955 - 2027)
 * Supports Year, Make, Model, Trim, Cab Style, Bed Length, and Wheelbase.
 * Comprehensive coverage back to our earliest catalog offerings (1955 Jeep CJ5 / Classic Trucks).
 */
(function(window) {
  'use strict';

  const VEHICLE_DATA = {
  "Ford": {
    "F-150": {
      "generations": [
        {
          "years": [
            2021,
            2022,
            2023,
            2024,
            2025,
            2026
          ],
          "gen_name": "14th Gen (2021-2026)",
          "trims": [
            "XL",
            "STX",
            "XLT",
            "Lariat",
            "King Ranch",
            "Platinum",
            "Tremor",
            "Raptor",
            "Raptor R",
            "Lightning Pro",
            "Lightning Flash",
            "Lightning Lariat",
            "Lightning Platinum"
          ],
          "cabs": [
            "Regular Cab",
            "SuperCab (Extended)",
            "SuperCrew (Crew Cab)"
          ],
          "beds": [
            {
              "name": "5.5 ft Short Bed (67.1 in)",
              "tag": "bed-5-5-ft",
              "wheelbases": [
                "145.4 in (SuperCrew)"
              ]
            },
            {
              "name": "6.5 ft Standard Bed (78.9 in)",
              "tag": "bed-6-5-ft",
              "wheelbases": [
                "141.5 in (Regular Cab)",
                "145.4 in (SuperCab)",
                "157.2 in (SuperCrew)"
              ]
            },
            {
              "name": "8.0 ft Long Bed (97.6 in)",
              "tag": "bed-8-0-ft",
              "wheelbases": [
                "141.5 in (Regular Cab)",
                "164.1 in (SuperCab)"
              ]
            }
          ]
        },
        {
          "years": [
            2015,
            2016,
            2017,
            2018,
            2019,
            2020
          ],
          "gen_name": "13th Gen (2015-2020)",
          "trims": [
            "XL",
            "XLT",
            "Lariat",
            "King Ranch",
            "Platinum",
            "Limited",
            "Raptor"
          ],
          "cabs": [
            "Regular Cab",
            "SuperCab",
            "SuperCrew"
          ],
          "beds": [
            {
              "name": "5.5 ft Short Bed (67.1 in)",
              "tag": "bed-5-5-ft",
              "wheelbases": [
                "145.0 in (SuperCrew)"
              ]
            },
            {
              "name": "6.5 ft Standard Bed (78.9 in)",
              "tag": "bed-6-5-ft",
              "wheelbases": [
                "141.1 in (Regular Cab)",
                "145.0 in (SuperCab)",
                "156.8 in (SuperCrew)"
              ]
            },
            {
              "name": "8.0 ft Long Bed (97.6 in)",
              "tag": "bed-8-0-ft",
              "wheelbases": [
                "141.1 in (Regular Cab)",
                "163.7 in (SuperCab)"
              ]
            }
          ]
        },
        {
          "years": [
            2009,
            2010,
            2011,
            2012,
            2013,
            2014
          ],
          "gen_name": "12th Gen (2009-2014)",
          "trims": [
            "XL",
            "STX",
            "XLT",
            "FX2",
            "FX4",
            "Lariat",
            "King Ranch",
            "Platinum",
            "SVT Raptor",
            "Limited"
          ],
          "cabs": [
            "Regular Cab",
            "SuperCab",
            "SuperCrew"
          ],
          "beds": [
            {
              "name": "5.5 ft Short Bed (67.0 in)",
              "tag": "bed-5-5-ft",
              "wheelbases": [
                "144.5 in (SuperCrew)"
              ]
            },
            {
              "name": "6.5 ft Standard Bed (78.8 in)",
              "tag": "bed-6-5-ft",
              "wheelbases": [
                "126.0 in (Regular)",
                "144.5 in (SuperCab)",
                "156.5 in (SuperCrew)"
              ]
            },
            {
              "name": "8.0 ft Long Bed (97.4 in)",
              "tag": "bed-8-0-ft",
              "wheelbases": [
                "144.5 in (Regular)",
                "163.1 in (SuperCab)"
              ]
            }
          ]
        },
        {
          "years": [
            2004,
            2005,
            2006,
            2007,
            2008
          ],
          "gen_name": "11th Gen (2004-2008)",
          "trims": [
            "XL",
            "STX",
            "XLT",
            "FX4",
            "Lariat",
            "King Ranch",
            "Harley-Davidson",
            "Limited"
          ],
          "cabs": [
            "Regular Cab",
            "SuperCab",
            "SuperCrew"
          ],
          "beds": [
            {
              "name": "5.5 ft Short Bed (67.0 in)",
              "tag": "bed-5-5-ft",
              "wheelbases": [
                "138.5 in (SuperCrew)"
              ]
            },
            {
              "name": "6.5 ft Standard Bed (78.8 in)",
              "tag": "bed-6-5-ft",
              "wheelbases": [
                "126.0 in (Regular)",
                "144.5 in (SuperCab)",
                "150.5 in (SuperCrew)"
              ]
            },
            {
              "name": "8.0 ft Long Bed (97.4 in)",
              "tag": "bed-8-0-ft",
              "wheelbases": [
                "144.5 in (Regular)",
                "163.0 in (SuperCab)"
              ]
            }
          ]
        },
        {
          "years": [
            1997,
            1998,
            1999,
            2000,
            2001,
            2002,
            2003
          ],
          "gen_name": "10th Gen (1997-2003)",
          "trims": [
            "Standard",
            "XL",
            "XLT",
            "Lariat",
            "SVT Lightning",
            "King Ranch",
            "Harley-Davidson"
          ],
          "cabs": [
            "Regular Cab",
            "SuperCab",
            "SuperCrew"
          ],
          "beds": [
            {
              "name": "5.5 ft Short Bed (Styleside)",
              "tag": "bed-5-5-ft",
              "wheelbases": [
                "138.8 in (SuperCrew)"
              ]
            },
            {
              "name": "6.5 ft Standard Bed (Styleside/Flareside)",
              "tag": "bed-6-5-ft",
              "wheelbases": [
                "119.9 in (Regular)",
                "138.8 in (SuperCab)"
              ]
            },
            {
              "name": "8.0 ft Long Bed (Styleside)",
              "tag": "bed-8-0-ft",
              "wheelbases": [
                "138.8 in (Regular)",
                "157.1 in (SuperCab)"
              ]
            }
          ]
        },
        {
          "years": [
            1992,
            1993,
            1994,
            1995,
            1996
          ],
          "gen_name": "9th Gen OBS (1992-1996)",
          "trims": [
            "Custom",
            "XL",
            "XLT",
            "XLT Lariat",
            "SVT Lightning",
            "Eddie Bauer"
          ],
          "cabs": [
            "Regular Cab",
            "SuperCab"
          ],
          "beds": [
            {
              "name": "6.75 ft Standard Bed (Styleside/Flareside)",
              "tag": "bed-6-75-ft",
              "wheelbases": [
                "116.8 in (Regular)",
                "138.8 in (SuperCab)"
              ]
            },
            {
              "name": "8.0 ft Long Bed (Styleside)",
              "tag": "bed-8-0-ft",
              "wheelbases": [
                "133.0 in (Regular)",
                "155.0 in (SuperCab)"
              ]
            }
          ]
        },
        {
          "years": [
            1987,
            1988,
            1989,
            1990,
            1991
          ],
          "gen_name": "8th Gen Bricknose (1987-1991)",
          "trims": [
            "Custom",
            "XL",
            "XLT Lariat"
          ],
          "cabs": [
            "Regular Cab",
            "SuperCab"
          ],
          "beds": [
            {
              "name": "6.75 ft Standard Bed",
              "tag": "bed-6-75-ft",
              "wheelbases": [
                "116.8 in (Regular)",
                "138.8 in (SuperCab)"
              ]
            },
            {
              "name": "8.0 ft Long Bed",
              "tag": "bed-8-0-ft",
              "wheelbases": [
                "133.0 in (Regular)",
                "155.0 in (SuperCab)"
              ]
            }
          ]
        },
        {
          "years": [
            1980,
            1981,
            1982,
            1983,
            1984,
            1985,
            1986
          ],
          "gen_name": "7th Gen Bullnose (1980-1986)",
          "trims": [
            "Custom",
            "XL",
            "XLS",
            "XLT",
            "XLT Lariat"
          ],
          "cabs": [
            "Regular Cab",
            "SuperCab"
          ],
          "beds": [
            {
              "name": "6.75 ft Standard Bed",
              "tag": "bed-6-75-ft",
              "wheelbases": [
                "116.8 in (Regular)",
                "138.8 in (SuperCab)"
              ]
            },
            {
              "name": "8.0 ft Long Bed",
              "tag": "bed-8-0-ft",
              "wheelbases": [
                "133.0 in (Regular)",
                "155.0 in (SuperCab)"
              ]
            }
          ]
        },
        {
          "years": [
            1975,
            1976,
            1977,
            1978,
            1979
          ],
          "gen_name": "6th Gen Dentside (1975-1979)",
          "trims": [
            "Custom",
            "Ranger",
            "Ranger XLT",
            "Ranger Lariat"
          ],
          "cabs": [
            "Regular Cab",
            "SuperCab"
          ],
          "beds": [
            {
              "name": "6.75 ft Standard Bed",
              "tag": "bed-6-75-ft",
              "wheelbases": [
                "117.0 in (Regular)",
                "139.0 in (SuperCab)"
              ]
            },
            {
              "name": "8.0 ft Long Bed",
              "tag": "bed-8-0-ft",
              "wheelbases": [
                "133.0 in (Regular)",
                "155.0 in (SuperCab)"
              ]
            }
          ]
        }
      ]
    },
    "F-100": {
      "generations": [
        {
          "years": [
            1973,
            1974,
            1975,
            1976,
            1977,
            1978,
            1979,
            1980,
            1981,
            1982,
            1983
          ],
          "gen_name": "6th & 7th Gen (1973-1983)",
          "trims": [
            "Custom",
            "Sport",
            "Ranger",
            "Ranger XLT",
            "XL"
          ],
          "cabs": [
            "Regular Cab",
            "SuperCab"
          ],
          "beds": [
            {
              "name": "6.5 ft Short Bed",
              "tag": "bed-6-5-ft",
              "wheelbases": [
                "117.0 in (Regular)"
              ]
            },
            {
              "name": "8.0 ft Long Bed",
              "tag": "bed-8-0-ft",
              "wheelbases": [
                "133.0 in (Regular)",
                "139.0 in (SuperCab)"
              ]
            }
          ]
        },
        {
          "years": [
            1955,
            1956,
            1957,
            1958,
            1959,
            1960,
            1961,
            1962,
            1963,
            1964,
            1965,
            1966,
            1967,
            1968,
            1969,
            1970,
            1971,
            1972
          ],
          "gen_name": "Classic F-100 (1955-1972)",
          "trims": [
            "Standard",
            "Custom Cab",
            "Ranger"
          ],
          "cabs": [
            "Regular Cab"
          ],
          "beds": [
            {
              "name": "6.5 ft Short Bed (Styleside/Stepside)",
              "tag": "bed-6-5-ft",
              "wheelbases": [
                "110.0 in",
                "115.0 in"
              ]
            },
            {
              "name": "8.0 ft Long Bed (Styleside/Stepside)",
              "tag": "bed-8-0-ft",
              "wheelbases": [
                "118.0 in",
                "131.0 in"
              ]
            }
          ]
        }
      ]
    },
    "F-250 Super Duty": {
      "generations": [
        {
          "years": [
            2023,
            2024,
            2025,
            2026
          ],
          "gen_name": "5th Gen (2023-2026)",
          "trims": [
            "XL",
            "XLT",
            "Lariat",
            "King Ranch",
            "Platinum",
            "Limited",
            "Tremor Off-Road"
          ],
          "cabs": [
            "Regular Cab",
            "SuperCab",
            "Crew Cab"
          ],
          "beds": [
            {
              "name": "6.75 ft Standard Bed (81.9 in)",
              "tag": "bed-6-75-ft",
              "wheelbases": [
                "148.0 in (SuperCab)",
                "160.0 in (Crew Cab)"
              ]
            },
            {
              "name": "8.0 ft Long Bed (98.1 in)",
              "tag": "bed-8-0-ft",
              "wheelbases": [
                "141.6 in (Regular Cab)",
                "164.2 in (SuperCab)",
                "176.0 in (Crew Cab)"
              ]
            }
          ]
        },
        {
          "years": [
            2017,
            2018,
            2019,
            2020,
            2021,
            2022
          ],
          "gen_name": "4th Gen (2017-2022)",
          "trims": [
            "XL",
            "XLT",
            "Lariat",
            "King Ranch",
            "Platinum",
            "Limited",
            "Tremor"
          ],
          "cabs": [
            "Regular Cab",
            "SuperCab",
            "Crew Cab"
          ],
          "beds": [
            {
              "name": "6.75 ft Standard Bed (81.9 in)",
              "tag": "bed-6-75-ft",
              "wheelbases": [
                "148.0 in (SuperCab)",
                "160.0 in (Crew Cab)"
              ]
            },
            {
              "name": "8.0 ft Long Bed (98.1 in)",
              "tag": "bed-8-0-ft",
              "wheelbases": [
                "141.6 in (Regular Cab)",
                "164.2 in (SuperCab)",
                "176.0 in (Crew Cab)"
              ]
            }
          ]
        },
        {
          "years": [
            2011,
            2012,
            2013,
            2014,
            2015,
            2016
          ],
          "gen_name": "3rd Gen Super Duty (2011-2016)",
          "trims": [
            "XL",
            "XLT",
            "Lariat",
            "King Ranch",
            "Platinum"
          ],
          "cabs": [
            "Regular Cab",
            "SuperCab",
            "Crew Cab"
          ],
          "beds": [
            {
              "name": "6.75 ft Standard Bed (81.8 in)",
              "tag": "bed-6-75-ft",
              "wheelbases": [
                "141.8 in (SuperCab)",
                "156.2 in (Crew Cab)"
              ]
            },
            {
              "name": "8.0 ft Long Bed (98.0 in)",
              "tag": "bed-8-0-ft",
              "wheelbases": [
                "137.0 in (Regular)",
                "158.0 in (SuperCab)",
                "172.4 in (Crew Cab)"
              ]
            }
          ]
        },
        {
          "years": [
            2008,
            2009,
            2010
          ],
          "gen_name": "2nd Gen Super Duty (2008-2010)",
          "trims": [
            "XL",
            "XLT",
            "FX4",
            "Lariat",
            "King Ranch",
            "Harley-Davidson"
          ],
          "cabs": [
            "Regular Cab",
            "SuperCab",
            "Crew Cab"
          ],
          "beds": [
            {
              "name": "6.75 ft Standard Bed (81.8 in)",
              "tag": "bed-6-75-ft",
              "wheelbases": [
                "141.8 in (SuperCab)",
                "156.2 in (Crew Cab)"
              ]
            },
            {
              "name": "8.0 ft Long Bed (98.0 in)",
              "tag": "bed-8-0-ft",
              "wheelbases": [
                "137.0 in (Regular)",
                "158.0 in (SuperCab)",
                "172.4 in (Crew Cab)"
              ]
            }
          ]
        },
        {
          "years": [
            1999,
            2000,
            2001,
            2002,
            2003,
            2004,
            2005,
            2006,
            2007
          ],
          "gen_name": "1st Gen Super Duty (1999-2007)",
          "trims": [
            "XL",
            "XLT",
            "Lariat",
            "King Ranch",
            "Harley-Davidson"
          ],
          "cabs": [
            "Regular Cab",
            "SuperCab",
            "Crew Cab"
          ],
          "beds": [
            {
              "name": "6.75 ft Standard Bed (81.8 in)",
              "tag": "bed-6-75-ft",
              "wheelbases": [
                "141.8 in (SuperCab)",
                "156.2 in (Crew Cab)"
              ]
            },
            {
              "name": "8.0 ft Long Bed (98.0 in)",
              "tag": "bed-8-0-ft",
              "wheelbases": [
                "137.0 in (Regular)",
                "158.0 in (SuperCab)",
                "172.4 in (Crew Cab)"
              ]
            }
          ]
        },
        {
          "years": [
            1955,
            1956,
            1957,
            1958,
            1959,
            1960,
            1961,
            1962,
            1963,
            1964,
            1965,
            1966,
            1967,
            1968,
            1969,
            1970,
            1971,
            1972,
            1973,
            1974,
            1975,
            1976,
            1977,
            1978,
            1979,
            1980,
            1981,
            1982,
            1983,
            1984,
            1985,
            1986,
            1987,
            1988,
            1989,
            1990,
            1991,
            1992,
            1993,
            1994,
            1995,
            1996,
            1997,
            1998
          ],
          "gen_name": "Classic F-250 (1955-1998)",
          "trims": [
            "Custom",
            "XL",
            "XLT",
            "XLT Lariat"
          ],
          "cabs": [
            "Regular Cab",
            "SuperCab",
            "Crew Cab"
          ],
          "beds": [
            {
              "name": "6.75 ft Bed",
              "tag": "bed-6-75-ft",
              "wheelbases": [
                "133.0 in",
                "155.0 in"
              ]
            },
            {
              "name": "8.0 ft Long Bed",
              "tag": "bed-8-0-ft",
              "wheelbases": [
                "133.0 in",
                "155.0 in",
                "168.4 in"
              ]
            }
          ]
        }
      ]
    },
    "F-350 Super Duty": {
      "generations": [
        {
          "years": [
            2017,
            2018,
            2019,
            2020,
            2021,
            2022,
            2023,
            2024,
            2025,
            2026
          ],
          "gen_name": "Super Duty (2017-2026)",
          "trims": [
            "XL",
            "XLT",
            "Lariat",
            "King Ranch",
            "Platinum",
            "Limited",
            "DRW / SRW"
          ],
          "cabs": [
            "Regular Cab",
            "SuperCab",
            "Crew Cab"
          ],
          "beds": [
            {
              "name": "6.75 ft Standard Bed (81.9 in)",
              "tag": "bed-6-75-ft",
              "wheelbases": [
                "148.0 in (SuperCab)",
                "160.0 in (Crew Cab)"
              ]
            },
            {
              "name": "8.0 ft Long Bed (98.1 in)",
              "tag": "bed-8-0-ft",
              "wheelbases": [
                "141.6 in (Regular Cab)",
                "164.2 in (SuperCab)",
                "176.0 in (Crew Cab)"
              ]
            }
          ]
        },
        {
          "years": [
            1999,
            2000,
            2001,
            2002,
            2003,
            2004,
            2005,
            2006,
            2007,
            2008,
            2009,
            2010,
            2011,
            2012,
            2013,
            2014,
            2015,
            2016
          ],
          "gen_name": "1st-3rd Gen Super Duty (1999-2016)",
          "trims": [
            "XL",
            "XLT",
            "Lariat",
            "King Ranch",
            "Platinum",
            "DRW / SRW"
          ],
          "cabs": [
            "Regular Cab",
            "SuperCab",
            "Crew Cab"
          ],
          "beds": [
            {
              "name": "6.75 ft Standard Bed",
              "tag": "bed-6-75-ft",
              "wheelbases": [
                "141.8 in (SuperCab)",
                "156.2 in (Crew Cab)"
              ]
            },
            {
              "name": "8.0 ft Long Bed",
              "tag": "bed-8-0-ft",
              "wheelbases": [
                "137.0 in (Regular)",
                "158.0 in (SuperCab)",
                "172.4 in (Crew Cab)"
              ]
            }
          ]
        },
        {
          "years": [
            1955,
            1956,
            1957,
            1958,
            1959,
            1960,
            1961,
            1962,
            1963,
            1964,
            1965,
            1966,
            1967,
            1968,
            1969,
            1970,
            1971,
            1972,
            1973,
            1974,
            1975,
            1976,
            1977,
            1978,
            1979,
            1980,
            1981,
            1982,
            1983,
            1984,
            1985,
            1986,
            1987,
            1988,
            1989,
            1990,
            1991,
            1992,
            1993,
            1994,
            1995,
            1996,
            1997,
            1998
          ],
          "gen_name": "Classic F-350 (1955-1998)",
          "trims": [
            "Custom",
            "XL",
            "XLT",
            "XLT Lariat"
          ],
          "cabs": [
            "Regular Cab",
            "SuperCab",
            "Crew Cab"
          ],
          "beds": [
            {
              "name": "8.0 ft Long Bed",
              "tag": "bed-8-0-ft",
              "wheelbases": [
                "133.0 in",
                "155.0 in",
                "168.4 in"
              ]
            }
          ]
        }
      ]
    },
    "Ranger": {
      "generations": [
        {
          "years": [
            2024,
            2025,
            2026
          ],
          "gen_name": "5th Gen (2024-2026)",
          "trims": [
            "XL",
            "XLT",
            "Lariat",
            "Raptor"
          ],
          "cabs": [
            "SuperCrew (Crew Cab)"
          ],
          "beds": [
            {
              "name": "5.0 ft Bed (59.6 in)",
              "tag": "bed-5-0-ft",
              "wheelbases": [
                "128.7 in"
              ]
            }
          ]
        },
        {
          "years": [
            2019,
            2020,
            2021,
            2022,
            2023
          ],
          "gen_name": "4th Gen (2019-2023)",
          "trims": [
            "XL",
            "XLT",
            "Lariat",
            "Tremor"
          ],
          "cabs": [
            "SuperCab (Extended)",
            "SuperCrew (Crew Cab)"
          ],
          "beds": [
            {
              "name": "5.0 ft Bed (SuperCrew)",
              "tag": "bed-5-0-ft",
              "wheelbases": [
                "126.8 in"
              ]
            },
            {
              "name": "6.0 ft Bed (SuperCab)",
              "tag": "bed-6-0-ft",
              "wheelbases": [
                "126.8 in"
              ]
            }
          ]
        },
        {
          "years": [
            1983,
            1984,
            1985,
            1986,
            1987,
            1988,
            1989,
            1990,
            1991,
            1992,
            1993,
            1994,
            1995,
            1996,
            1997,
            1998,
            1999,
            2000,
            2001,
            2002,
            2003,
            2004,
            2005,
            2006,
            2007,
            2008,
            2009,
            2010,
            2011
          ],
          "gen_name": "Classic Ranger (1983-2011)",
          "trims": [
            "S",
            "XL",
            "XLT",
            "STX",
            "Sport",
            "FX4 Off-Road"
          ],
          "cabs": [
            "Regular Cab",
            "SuperCab"
          ],
          "beds": [
            {
              "name": "6.0 ft Bed (72.0 in)",
              "tag": "bed-6-0-ft",
              "wheelbases": [
                "111.6 in (Regular)",
                "125.9 in (SuperCab)"
              ]
            },
            {
              "name": "7.0 ft Long Bed (84.0 in)",
              "tag": "bed-7-0-ft",
              "wheelbases": [
                "117.5 in (Regular)"
              ]
            }
          ]
        }
      ]
    },
    "Bronco": {
      "generations": [
        {
          "years": [
            2021,
            2022,
            2023,
            2024,
            2025,
            2026
          ],
          "gen_name": "6th Gen (2021-2026)",
          "trims": [
            "Base",
            "Big Bend",
            "Black Diamond",
            "Outer Banks",
            "Badlands",
            "Wildtrak",
            "Everglades",
            "Heritage",
            "Raptor"
          ],
          "cabs": [
            "2-Door SUV",
            "4-Door SUV"
          ],
          "beds": [
            {
              "name": "Rear Cargo / Roof Platform",
              "tag": "bronco-cargo",
              "wheelbases": [
                "100.4 in (2-Door)",
                "116.1 in (4-Door)"
              ]
            }
          ]
        },
        {
          "years": [
            1966,
            1967,
            1968,
            1969,
            1970,
            1971,
            1972,
            1973,
            1974,
            1975,
            1976,
            1977,
            1978,
            1979,
            1980,
            1981,
            1982,
            1983,
            1984,
            1985,
            1986,
            1987,
            1988,
            1989,
            1990,
            1991,
            1992,
            1993,
            1994,
            1995,
            1996
          ],
          "gen_name": "Classic Bronco (1966-1996)",
          "trims": [
            "Custom",
            "Ranger",
            "XL",
            "XLT",
            "Eddie Bauer"
          ],
          "cabs": [
            "2-Door Full-Size SUV / Removable Hardtop"
          ],
          "beds": [
            {
              "name": "Rear Cargo / Interior Bed",
              "tag": "bronco-classic-cargo",
              "wheelbases": [
                "92.0 in (1966-77)",
                "104.7 in (1978-96)"
              ]
            }
          ]
        }
      ]
    },
    "Maverick": {
      "generations": [
        {
          "years": [
            2022,
            2023,
            2024,
            2025,
            2026
          ],
          "gen_name": "1st Gen (2022-2026)",
          "trims": [
            "XL",
            "XLT",
            "Lariat",
            "Tremor",
            "Lobo"
          ],
          "cabs": [
            "Crew Cab"
          ],
          "beds": [
            {
              "name": "4.5 ft Bed (54.4 in)",
              "tag": "bed-4-5-ft",
              "wheelbases": [
                "121.1 in"
              ]
            }
          ]
        }
      ]
    }
  },
  "Chevrolet": {
    "Silverado 1500": {
      "generations": [
        {
          "years": [
            2019,
            2020,
            2021,
            2022,
            2023,
            2024,
            2025,
            2026
          ],
          "gen_name": "4th Gen (2019-2026 / T1XX)",
          "trims": [
            "WT",
            "Custom",
            "Custom Trail Boss",
            "LT",
            "RST",
            "LT Trail Boss",
            "LTZ",
            "High Country",
            "ZR2",
            "ZR2 Bison"
          ],
          "cabs": [
            "Regular Cab",
            "Double Cab (Extended)",
            "Crew Cab (Short & Standard)"
          ],
          "beds": [
            {
              "name": "5.8 ft Short Bed (69.9 in)",
              "tag": "bed-5-8-ft",
              "wheelbases": [
                "147.5 in (Crew Cab)"
              ]
            },
            {
              "name": "6.6 ft Standard Bed (79.4 in)",
              "tag": "bed-6-6-ft",
              "wheelbases": [
                "139.6 in (Regular Cab)",
                "147.5 in (Double Cab)",
                "157.1 in (Crew Cab)"
              ]
            },
            {
              "name": "8.2 ft Long Bed (98.2 in)",
              "tag": "bed-8-2-ft",
              "wheelbases": [
                "139.6 in (Regular Cab)"
              ]
            }
          ]
        },
        {
          "years": [
            2014,
            2015,
            2016,
            2017,
            2018
          ],
          "gen_name": "3rd Gen (2014-2018 / K2XX)",
          "trims": [
            "WT",
            "LS",
            "Custom",
            "LT",
            "LTZ",
            "High Country"
          ],
          "cabs": [
            "Regular Cab",
            "Double Cab",
            "Crew Cab"
          ],
          "beds": [
            {
              "name": "5.8 ft Short Bed (69.3 in)",
              "tag": "bed-5-8-ft",
              "wheelbases": [
                "143.5 in (Crew Cab)"
              ]
            },
            {
              "name": "6.6 ft Standard Bed (78.9 in)",
              "tag": "bed-6-6-ft",
              "wheelbases": [
                "133.0 in (Regular Cab)",
                "143.5 in (Double Cab)",
                "153.0 in (Crew Cab)"
              ]
            },
            {
              "name": "8.2 ft Long Bed (97.8 in)",
              "tag": "bed-8-2-ft",
              "wheelbases": [
                "133.0 in (Regular Cab)"
              ]
            }
          ]
        },
        {
          "years": [
            2007,
            2008,
            2009,
            2010,
            2011,
            2012,
            2013
          ],
          "gen_name": "2nd Gen (2007-2013 / GMT900)",
          "trims": [
            "WT",
            "LS",
            "LT",
            "LTZ"
          ],
          "cabs": [
            "Regular Cab",
            "Extended Cab",
            "Crew Cab"
          ],
          "beds": [
            {
              "name": "5.8 ft Short Bed (69.3 in)",
              "tag": "bed-5-8-ft",
              "wheelbases": [
                "143.5 in (Crew Cab)"
              ]
            },
            {
              "name": "6.6 ft Standard Bed (78.9 in)",
              "tag": "bed-6-6-ft",
              "wheelbases": [
                "119.0 in (Regular)",
                "133.9 in (Ext)",
                "143.5 in (Crew)"
              ]
            },
            {
              "name": "8.0 ft Long Bed (97.8 in)",
              "tag": "bed-8-0-ft",
              "wheelbases": [
                "133.0 in (Regular)",
                "157.5 in (Ext)"
              ]
            }
          ]
        },
        {
          "years": [
            1999,
            2000,
            2001,
            2002,
            2003,
            2004,
            2005,
            2006,
            2007
          ],
          "gen_name": "1st Gen & Classic (1999-2007 / GMT800)",
          "trims": [
            "Base",
            "WT",
            "LS",
            "LT",
            "SS"
          ],
          "cabs": [
            "Regular Cab",
            "Extended Cab",
            "Crew Cab"
          ],
          "beds": [
            {
              "name": "5.8 ft Short Bed (68.4 in)",
              "tag": "bed-5-8-ft",
              "wheelbases": [
                "143.5 in (Crew Cab)"
              ]
            },
            {
              "name": "6.6 ft Standard Bed (78.7 in)",
              "tag": "bed-6-6-ft",
              "wheelbases": [
                "119.0 in (Regular)",
                "143.5 in (Ext)"
              ]
            },
            {
              "name": "8.0 ft Long Bed (97.6 in)",
              "tag": "bed-8-0-ft",
              "wheelbases": [
                "133.0 in (Regular)",
                "157.5 in (Ext)"
              ]
            }
          ]
        }
      ]
    },
    "C1500 / K1500 (OBS)": {
      "generations": [
        {
          "years": [
            1988,
            1989,
            1990,
            1991,
            1992,
            1993,
            1994,
            1995,
            1996,
            1997,
            1998,
            1999
          ],
          "gen_name": "GMT400 OBS (1988-1999)",
          "trims": [
            "Cheyenne",
            "Scottsdale",
            "Silverado",
            "454 SS",
            "Sport"
          ],
          "cabs": [
            "Regular Cab",
            "Extended Cab",
            "Crew Cab"
          ],
          "beds": [
            {
              "name": "6.5 ft Standard Bed (Fleetside/Sportside)",
              "tag": "bed-6-5-ft",
              "wheelbases": [
                "117.5 in (Regular)",
                "141.5 in (Ext)"
              ]
            },
            {
              "name": "8.0 ft Long Bed (Fleetside)",
              "tag": "bed-8-0-ft",
              "wheelbases": [
                "131.5 in (Regular)",
                "155.5 in (Ext)",
                "168.5 in (Crew)"
              ]
            }
          ]
        }
      ]
    },
    "C10 / K10 (Square Body)": {
      "generations": [
        {
          "years": [
            1973,
            1974,
            1975,
            1976,
            1977,
            1978,
            1979,
            1980,
            1981,
            1982,
            1983,
            1984,
            1985,
            1986,
            1987
          ],
          "gen_name": "Square Body (1973-1987)",
          "trims": [
            "Custom",
            "Custom Deluxe",
            "Scottsdale",
            "Cheyenne",
            "Silverado"
          ],
          "cabs": [
            "Regular Cab",
            "Bonus Cab",
            "Crew Cab"
          ],
          "beds": [
            {
              "name": "6.5 ft Short Bed (Fleetside/Stepside)",
              "tag": "bed-6-5-ft",
              "wheelbases": [
                "117.5 in (Regular)"
              ]
            },
            {
              "name": "8.0 ft Long Bed (Fleetside/Stepside)",
              "tag": "bed-8-0-ft",
              "wheelbases": [
                "131.5 in (Regular)",
                "164.5 in (Crew)"
              ]
            }
          ]
        },
        {
          "years": [
            1960,
            1961,
            1962,
            1963,
            1964,
            1965,
            1966,
            1967,
            1968,
            1969,
            1970,
            1971,
            1972
          ],
          "gen_name": "Action Line / Classic C10 (1960-1972)",
          "trims": [
            "Base",
            "Custom",
            "Custom 10",
            "Cheyenne",
            "CST"
          ],
          "cabs": [
            "Regular Cab"
          ],
          "beds": [
            {
              "name": "6.5 ft Short Bed (Fleetside/Stepside)",
              "tag": "bed-6-5-ft",
              "wheelbases": [
                "115.0 in"
              ]
            },
            {
              "name": "8.0 ft Long Bed (Fleetside/Stepside)",
              "tag": "bed-8-0-ft",
              "wheelbases": [
                "127.0 in"
              ]
            }
          ]
        }
      ]
    },
    "Silverado 2500HD / 3500HD": {
      "generations": [
        {
          "years": [
            2020,
            2021,
            2022,
            2023,
            2024,
            2025,
            2026
          ],
          "gen_name": "Heavy Duty (2020-2026)",
          "trims": [
            "WT",
            "Custom",
            "LT",
            "LTZ",
            "High Country",
            "ZR2",
            "ZR2 Bison"
          ],
          "cabs": [
            "Regular Cab",
            "Double Cab",
            "Crew Cab"
          ],
          "beds": [
            {
              "name": "6.9 ft Standard Bed (82.25 in)",
              "tag": "bed-6-9-ft",
              "wheelbases": [
                "149.0 in (Double Cab)",
                "159.0 in (Crew Cab)"
              ]
            },
            {
              "name": "8.2 ft Long Bed (98.27 in)",
              "tag": "bed-8-2-ft",
              "wheelbases": [
                "142.0 in (Regular Cab)",
                "162.0 in (Double Cab)",
                "172.0 in (Crew Cab)"
              ]
            }
          ]
        },
        {
          "years": [
            2001,
            2002,
            2003,
            2004,
            2005,
            2006,
            2007,
            2008,
            2009,
            2010,
            2011,
            2012,
            2013,
            2014,
            2015,
            2016,
            2017,
            2018,
            2019
          ],
          "gen_name": "Heavy Duty (2001-2019)",
          "trims": [
            "WT",
            "LT",
            "LTZ",
            "High Country"
          ],
          "cabs": [
            "Regular Cab",
            "Extended/Double Cab",
            "Crew Cab"
          ],
          "beds": [
            {
              "name": "6.6 ft Standard Bed",
              "tag": "bed-6-6-ft",
              "wheelbases": [
                "144.2 in",
                "153.7 in"
              ]
            },
            {
              "name": "8.0 ft Long Bed",
              "tag": "bed-8-0-ft",
              "wheelbases": [
                "133.7 in",
                "158.2 in",
                "167.7 in"
              ]
            }
          ]
        },
        {
          "years": [
            1973,
            1974,
            1975,
            1976,
            1977,
            1978,
            1979,
            1980,
            1981,
            1982,
            1983,
            1984,
            1985,
            1986,
            1987,
            1988,
            1989,
            1990,
            1991,
            1992,
            1993,
            1994,
            1995,
            1996,
            1997,
            1998,
            1999,
            2000
          ],
          "gen_name": "Classic C20/K20/C2500/K2500 (1973-2000)",
          "trims": [
            "Custom",
            "Scottsdale",
            "Cheyenne",
            "Silverado"
          ],
          "cabs": [
            "Regular Cab",
            "Bonus/Extended Cab",
            "Crew Cab"
          ],
          "beds": [
            {
              "name": "8.0 ft Long Bed",
              "tag": "bed-8-0-ft",
              "wheelbases": [
                "131.5 in",
                "155.5 in",
                "168.5 in"
              ]
            }
          ]
        }
      ]
    },
    "Colorado": {
      "generations": [
        {
          "years": [
            2023,
            2024,
            2025,
            2026
          ],
          "gen_name": "3rd Gen (2023-2026)",
          "trims": [
            "WT",
            "LT",
            "Trail Boss",
            "Z71",
            "ZR2",
            "ZR2 Bison"
          ],
          "cabs": [
            "Crew Cab"
          ],
          "beds": [
            {
              "name": "5.2 ft Bed (61.7 in)",
              "tag": "bed-5-2-ft",
              "wheelbases": [
                "131.4 in"
              ]
            }
          ]
        },
        {
          "years": [
            2015,
            2016,
            2017,
            2018,
            2019,
            2020,
            2021,
            2022
          ],
          "gen_name": "2nd Gen (2015-2022)",
          "trims": [
            "Base",
            "WT",
            "LT",
            "Z71",
            "ZR2"
          ],
          "cabs": [
            "Extended Cab",
            "Crew Cab"
          ],
          "beds": [
            {
              "name": "5.2 ft Short Bed (Crew Cab)",
              "tag": "bed-5-2-ft",
              "wheelbases": [
                "128.3 in"
              ]
            },
            {
              "name": "6.2 ft Long Bed (Ext/Crew)",
              "tag": "bed-6-2-ft",
              "wheelbases": [
                "128.3 in (Ext)",
                "140.5 in (Crew)"
              ]
            }
          ]
        },
        {
          "years": [
            2004,
            2005,
            2006,
            2007,
            2008,
            2009,
            2010,
            2011,
            2012
          ],
          "gen_name": "1st Gen (2004-2012)",
          "trims": [
            "Base",
            "WT",
            "LS",
            "LT",
            "Z71",
            "Z85"
          ],
          "cabs": [
            "Regular Cab",
            "Extended Cab",
            "Crew Cab"
          ],
          "beds": [
            {
              "name": "5.0 ft Bed (Crew Cab)",
              "tag": "bed-5-0-ft",
              "wheelbases": [
                "126.0 in"
              ]
            },
            {
              "name": "6.0 ft Bed (Regular/Ext)",
              "tag": "bed-6-0-ft",
              "wheelbases": [
                "111.3 in",
                "126.0 in"
              ]
            }
          ]
        }
      ]
    }
  },
  "GMC": {
    "Sierra 1500": {
      "generations": [
        {
          "years": [
            2019,
            2020,
            2021,
            2022,
            2023,
            2024,
            2025,
            2026
          ],
          "gen_name": "Next Gen (2019-2026)",
          "trims": [
            "Pro",
            "SLE",
            "Elevation",
            "SLT",
            "AT4",
            "AT4X",
            "Denali",
            "Denali Ultimate"
          ],
          "cabs": [
            "Regular Cab",
            "Double Cab",
            "Crew Cab"
          ],
          "beds": [
            {
              "name": "5.8 ft Short Bed (69.9 in)",
              "tag": "bed-5-8-ft",
              "wheelbases": [
                "147.5 in (Crew Cab)"
              ]
            },
            {
              "name": "6.6 ft Standard Bed (79.4 in)",
              "tag": "bed-6-6-ft",
              "wheelbases": [
                "139.6 in (Regular)",
                "147.5 in (Double)",
                "157.1 in (Crew)"
              ]
            },
            {
              "name": "8.2 ft Long Bed (98.2 in)",
              "tag": "bed-8-2-ft",
              "wheelbases": [
                "139.6 in (Regular)"
              ]
            }
          ]
        },
        {
          "years": [
            2014,
            2015,
            2016,
            2017,
            2018
          ],
          "gen_name": "3rd Gen (2014-2018 / K2XX)",
          "trims": [
            "Base",
            "SLE",
            "SLT",
            "All Terrain",
            "Denali"
          ],
          "cabs": [
            "Regular Cab",
            "Double Cab",
            "Crew Cab"
          ],
          "beds": [
            {
              "name": "5.8 ft Short Bed (69.3 in)",
              "tag": "bed-5-8-ft",
              "wheelbases": [
                "143.5 in (Crew Cab)"
              ]
            },
            {
              "name": "6.6 ft Standard Bed (78.9 in)",
              "tag": "bed-6-6-ft",
              "wheelbases": [
                "133.0 in (Regular)",
                "143.5 in (Double)",
                "153.0 in (Crew)"
              ]
            },
            {
              "name": "8.2 ft Long Bed (97.8 in)",
              "tag": "bed-8-2-ft",
              "wheelbases": [
                "133.0 in (Regular)"
              ]
            }
          ]
        },
        {
          "years": [
            2007,
            2008,
            2009,
            2010,
            2011,
            2012,
            2013
          ],
          "gen_name": "2nd Gen (2007-2013 / GMT900)",
          "trims": [
            "Work Truck",
            "SLE",
            "SLT",
            "Denali"
          ],
          "cabs": [
            "Regular Cab",
            "Extended Cab",
            "Crew Cab"
          ],
          "beds": [
            {
              "name": "5.8 ft Short Bed (69.3 in)",
              "tag": "bed-5-8-ft",
              "wheelbases": [
                "143.5 in (Crew)"
              ]
            },
            {
              "name": "6.6 ft Standard Bed (78.9 in)",
              "tag": "bed-6-6-ft",
              "wheelbases": [
                "119.0 in (Regular)",
                "133.9 in (Ext)",
                "143.5 in (Crew)"
              ]
            },
            {
              "name": "8.0 ft Long Bed (97.8 in)",
              "tag": "bed-8-0-ft",
              "wheelbases": [
                "133.0 in (Regular)",
                "157.5 in (Ext)"
              ]
            }
          ]
        },
        {
          "years": [
            1999,
            2000,
            2001,
            2002,
            2003,
            2004,
            2005,
            2006,
            2007
          ],
          "gen_name": "1st Gen & Classic (1999-2007 / GMT800)",
          "trims": [
            "SL",
            "SLE",
            "SLT",
            "C3",
            "Denali"
          ],
          "cabs": [
            "Regular Cab",
            "Extended Cab",
            "Crew Cab"
          ],
          "beds": [
            {
              "name": "5.8 ft Short Bed (68.4 in)",
              "tag": "bed-5-8-ft",
              "wheelbases": [
                "143.5 in (Crew)"
              ]
            },
            {
              "name": "6.6 ft Standard Bed (78.7 in)",
              "tag": "bed-6-6-ft",
              "wheelbases": [
                "119.0 in (Regular)",
                "143.5 in (Ext)"
              ]
            },
            {
              "name": "8.0 ft Long Bed (97.6 in)",
              "tag": "bed-8-0-ft",
              "wheelbases": [
                "133.0 in (Regular)",
                "157.5 in (Ext)"
              ]
            }
          ]
        },
        {
          "years": [
            1988,
            1989,
            1990,
            1991,
            1992,
            1993,
            1994,
            1995,
            1996,
            1997,
            1998
          ],
          "gen_name": "GMT400 C1500/K1500 (1988-1998)",
          "trims": [
            "Sierra",
            "Sierra SLX",
            "Sierra SLE",
            "Sierra Special"
          ],
          "cabs": [
            "Regular Cab",
            "Extended Cab",
            "Crew Cab"
          ],
          "beds": [
            {
              "name": "6.5 ft Standard Bed",
              "tag": "bed-6-5-ft",
              "wheelbases": [
                "117.5 in (Regular)",
                "141.5 in (Ext)"
              ]
            },
            {
              "name": "8.0 ft Long Bed",
              "tag": "bed-8-0-ft",
              "wheelbases": [
                "131.5 in (Regular)",
                "155.5 in (Ext)"
              ]
            }
          ]
        },
        {
          "years": [
            1960,
            1961,
            1962,
            1963,
            1964,
            1965,
            1966,
            1967,
            1968,
            1969,
            1970,
            1971,
            1972,
            1973,
            1974,
            1975,
            1976,
            1977,
            1978,
            1979,
            1980,
            1981,
            1982,
            1983,
            1984,
            1985,
            1986,
            1987
          ],
          "gen_name": "Classic C15/C1500/Square Body (1960-1987)",
          "trims": [
            "Custom",
            "Super Custom",
            "Sierra",
            "Sierra Classic",
            "High Sierra"
          ],
          "cabs": [
            "Regular Cab",
            "Crew Cab"
          ],
          "beds": [
            {
              "name": "6.5 ft Short Bed",
              "tag": "bed-6-5-ft",
              "wheelbases": [
                "115.0 in",
                "117.5 in"
              ]
            },
            {
              "name": "8.0 ft Long Bed",
              "tag": "bed-8-0-ft",
              "wheelbases": [
                "127.0 in",
                "131.5 in"
              ]
            }
          ]
        }
      ]
    },
    "Sierra 2500HD / 3500HD": {
      "generations": [
        {
          "years": [
            2020,
            2021,
            2022,
            2023,
            2024,
            2025,
            2026
          ],
          "gen_name": "HD Next Gen (2020-2026)",
          "trims": [
            "Pro",
            "SLE",
            "SLT",
            "AT4",
            "AT4X",
            "Denali",
            "Denali Ultimate"
          ],
          "cabs": [
            "Regular Cab",
            "Double Cab",
            "Crew Cab"
          ],
          "beds": [
            {
              "name": "6.9 ft Standard Bed (82.25 in)",
              "tag": "bed-6-9-ft",
              "wheelbases": [
                "149.0 in",
                "159.0 in"
              ]
            },
            {
              "name": "8.2 ft Long Bed (98.27 in)",
              "tag": "bed-8-2-ft",
              "wheelbases": [
                "142.0 in",
                "162.0 in",
                "172.0 in"
              ]
            }
          ]
        },
        {
          "years": [
            2001,
            2002,
            2003,
            2004,
            2005,
            2006,
            2007,
            2008,
            2009,
            2010,
            2011,
            2012,
            2013,
            2014,
            2015,
            2016,
            2017,
            2018,
            2019
          ],
          "gen_name": "Heavy Duty (2001-2019)",
          "trims": [
            "Work Truck",
            "SLE",
            "SLT",
            "Denali"
          ],
          "cabs": [
            "Regular Cab",
            "Extended/Double Cab",
            "Crew Cab"
          ],
          "beds": [
            {
              "name": "6.6 ft Standard Bed",
              "tag": "bed-6-6-ft",
              "wheelbases": [
                "144.2 in",
                "153.7 in"
              ]
            },
            {
              "name": "8.0 ft Long Bed",
              "tag": "bed-8-0-ft",
              "wheelbases": [
                "133.7 in",
                "158.2 in",
                "167.7 in"
              ]
            }
          ]
        },
        {
          "years": [
            1973,
            1974,
            1975,
            1976,
            1977,
            1978,
            1979,
            1980,
            1981,
            1982,
            1983,
            1984,
            1985,
            1986,
            1987,
            1988,
            1989,
            1990,
            1991,
            1992,
            1993,
            1994,
            1995,
            1996,
            1997,
            1998,
            1999,
            2000
          ],
          "gen_name": "Classic C25/C2500 (1973-2000)",
          "trims": [
            "Sierra",
            "High Sierra",
            "Sierra Classic"
          ],
          "cabs": [
            "Regular Cab",
            "Extended Cab",
            "Crew Cab"
          ],
          "beds": [
            {
              "name": "8.0 ft Long Bed",
              "tag": "bed-8-0-ft",
              "wheelbases": [
                "131.5 in",
                "155.5 in",
                "168.5 in"
              ]
            }
          ]
        }
      ]
    },
    "Canyon": {
      "generations": [
        {
          "years": [
            2023,
            2024,
            2025,
            2026
          ],
          "gen_name": "Next Gen (2023-2026)",
          "trims": [
            "Elevation",
            "AT4",
            "AT4X",
            "AT4X AEV",
            "Denali"
          ],
          "cabs": [
            "Crew Cab"
          ],
          "beds": [
            {
              "name": "5.2 ft Bed (61.7 in)",
              "tag": "bed-5-2-ft",
              "wheelbases": [
                "131.4 in"
              ]
            }
          ]
        },
        {
          "years": [
            2015,
            2016,
            2017,
            2018,
            2019,
            2020,
            2021,
            2022
          ],
          "gen_name": "2nd Gen (2015-2022)",
          "trims": [
            "Base",
            "SLE",
            "SLT",
            "All Terrain",
            "AT4",
            "Denali"
          ],
          "cabs": [
            "Extended Cab",
            "Crew Cab"
          ],
          "beds": [
            {
              "name": "5.2 ft Short Bed",
              "tag": "bed-5-2-ft",
              "wheelbases": [
                "128.3 in"
              ]
            },
            {
              "name": "6.2 ft Long Bed",
              "tag": "bed-6-2-ft",
              "wheelbases": [
                "128.3 in",
                "140.5 in"
              ]
            }
          ]
        },
        {
          "years": [
            2004,
            2005,
            2006,
            2007,
            2008,
            2009,
            2010,
            2011,
            2012
          ],
          "gen_name": "1st Gen (2004-2012)",
          "trims": [
            "SL",
            "SLE",
            "SLT",
            "Z71",
            "Z85"
          ],
          "cabs": [
            "Regular Cab",
            "Extended Cab",
            "Crew Cab"
          ],
          "beds": [
            {
              "name": "5.0 ft Bed (Crew Cab)",
              "tag": "bed-5-0-ft",
              "wheelbases": [
                "126.0 in"
              ]
            },
            {
              "name": "6.0 ft Bed (Regular/Ext)",
              "tag": "bed-6-0-ft",
              "wheelbases": [
                "111.3 in",
                "126.0 in"
              ]
            }
          ]
        }
      ]
    }
  },
  "Dodge": {
    "Ram 1500 (Pre-2010)": {
      "generations": [
        {
          "years": [
            2002,
            2003,
            2004,
            2005,
            2006,
            2007,
            2008,
            2009
          ],
          "gen_name": "3rd Gen (2002-2009)",
          "trims": [
            "ST",
            "SLT",
            "Sport",
            "Laramie",
            "TRX4",
            "SRT-10",
            "Rumble Bee",
            "Power Wagon"
          ],
          "cabs": [
            "Regular Cab",
            "Quad Cab",
            "Mega Cab"
          ],
          "beds": [
            {
              "name": "6.3 ft Short Bed (75.9 in)",
              "tag": "bed-6-3-ft",
              "wheelbases": [
                "120.5 in (Regular)",
                "140.5 in (Quad)",
                "160.5 in (Mega)"
              ]
            },
            {
              "name": "8.0 ft Long Bed (97.9 in)",
              "tag": "bed-8-0-ft",
              "wheelbases": [
                "140.5 in (Regular)",
                "160.5 in (Quad)"
              ]
            }
          ]
        },
        {
          "years": [
            1994,
            1995,
            1996,
            1997,
            1998,
            1999,
            2000,
            2001
          ],
          "gen_name": "2nd Gen (1994-2001)",
          "trims": [
            "Standard",
            "WS",
            "ST",
            "LT",
            "SLT",
            "SLT Laramie",
            "SS/T",
            "Sport"
          ],
          "cabs": [
            "Regular Cab",
            "Club Cab (Extended)",
            "Quad Cab"
          ],
          "beds": [
            {
              "name": "6.5 ft Standard Bed",
              "tag": "bed-6-5-ft",
              "wheelbases": [
                "118.7 in (Regular)",
                "138.7 in (Club/Quad)"
              ]
            },
            {
              "name": "8.0 ft Long Bed",
              "tag": "bed-8-0-ft",
              "wheelbases": [
                "134.7 in (Regular)",
                "154.7 in (Club/Quad)"
              ]
            }
          ]
        },
        {
          "years": [
            1981,
            1982,
            1983,
            1984,
            1985,
            1986,
            1987,
            1988,
            1989,
            1990,
            1991,
            1992,
            1993
          ],
          "gen_name": "1st Gen D/W Series (1981-1993)",
          "trims": [
            "Custom",
            "Royal",
            "Royal SE",
            "Power Ram",
            "W100",
            "W150"
          ],
          "cabs": [
            "Regular Cab",
            "Club Cab"
          ],
          "beds": [
            {
              "name": "6.5 ft Short Bed (Sweptline/Utiline)",
              "tag": "bed-6-5-ft",
              "wheelbases": [
                "115.0 in"
              ]
            },
            {
              "name": "8.0 ft Long Bed (Sweptline)",
              "tag": "bed-8-0-ft",
              "wheelbases": [
                "131.0 in",
                "149.0 in"
              ]
            }
          ]
        },
        {
          "years": [
            1957,
            1958,
            1959,
            1960,
            1961,
            1962,
            1963,
            1964,
            1965,
            1966,
            1967,
            1968,
            1969,
            1970,
            1971,
            1972,
            1973,
            1974,
            1975,
            1976,
            1977,
            1978,
            1979,
            1980
          ],
          "gen_name": "Classic D/W Series (1957-1980)",
          "trims": [
            "Custom",
            "Adventurer",
            "Sweptline",
            "W100",
            "W200"
          ],
          "cabs": [
            "Regular Cab",
            "Club Cab"
          ],
          "beds": [
            {
              "name": "6.5 ft Short Bed",
              "tag": "bed-6-5-ft",
              "wheelbases": [
                "114.0 in",
                "115.0 in"
              ]
            },
            {
              "name": "8.0 ft Long Bed",
              "tag": "bed-8-0-ft",
              "wheelbases": [
                "128.0 in",
                "131.0 in"
              ]
            }
          ]
        }
      ]
    },
    "Ram 2500 / 3500 (Pre-2010)": {
      "generations": [
        {
          "years": [
            2003,
            2004,
            2005,
            2006,
            2007,
            2008,
            2009
          ],
          "gen_name": "3rd Gen Heavy Duty (2003-2009)",
          "trims": [
            "ST",
            "SLT",
            "Laramie",
            "Power Wagon"
          ],
          "cabs": [
            "Regular Cab",
            "Quad Cab",
            "Mega Cab"
          ],
          "beds": [
            {
              "name": "6.3 ft Bed (75.9 in)",
              "tag": "bed-6-3-ft",
              "wheelbases": [
                "140.5 in",
                "160.5 in"
              ]
            },
            {
              "name": "8.0 ft Long Bed (97.9 in)",
              "tag": "bed-8-0-ft",
              "wheelbases": [
                "140.5 in",
                "160.5 in"
              ]
            }
          ]
        },
        {
          "years": [
            1994,
            1995,
            1996,
            1997,
            1998,
            1999,
            2000,
            2001,
            2002
          ],
          "gen_name": "2nd Gen Heavy Duty (1994-2002)",
          "trims": [
            "ST",
            "SLT",
            "Laramie"
          ],
          "cabs": [
            "Regular Cab",
            "Club Cab",
            "Quad Cab"
          ],
          "beds": [
            {
              "name": "6.5 ft Bed",
              "tag": "bed-6-5-ft",
              "wheelbases": [
                "138.7 in"
              ]
            },
            {
              "name": "8.0 ft Long Bed",
              "tag": "bed-8-0-ft",
              "wheelbases": [
                "134.7 in",
                "154.7 in"
              ]
            }
          ]
        },
        {
          "years": [
            1960,
            1961,
            1962,
            1963,
            1964,
            1965,
            1966,
            1967,
            1968,
            1969,
            1970,
            1971,
            1972,
            1973,
            1974,
            1975,
            1976,
            1977,
            1978,
            1979,
            1980,
            1981,
            1982,
            1983,
            1984,
            1985,
            1986,
            1987,
            1988,
            1989,
            1990,
            1991,
            1992,
            1993
          ],
          "gen_name": "Classic W200/W250/W350 (1960-1993)",
          "trims": [
            "Custom",
            "Power Ram",
            "W250",
            "W350"
          ],
          "cabs": [
            "Regular Cab",
            "Club Cab",
            "Crew Cab"
          ],
          "beds": [
            {
              "name": "8.0 ft Long Bed",
              "tag": "bed-8-0-ft",
              "wheelbases": [
                "131.0 in",
                "149.0 in",
                "165.0 in"
              ]
            }
          ]
        }
      ]
    },
    "Durango": {
      "generations": [
        {
          "years": [
            2014,
            2015,
            2016,
            2017,
            2018,
            2019,
            2020,
            2021,
            2022,
            2023,
            2024,
            2025,
            2026,
            2027
          ],
          "gen_name": "3rd Gen (2014-2027 / WD Platform)",
          "trims": [
            "SXT",
            "GT",
            "R/T",
            "Citadel",
            "SRT 392",
            "SRT Hellcat"
          ],
          "cabs": [
            "4-Door SUV"
          ],
          "beds": [
            {
              "name": "Interior Cargo / Flat Tow",
              "tag": "durango-cargo",
              "wheelbases": [
                "119.8 in"
              ]
            }
          ]
        }
      ]
    }
  },
  "RAM": {
    "1500": {
      "generations": [
        {
          "years": [
            2019,
            2020,
            2021,
            2022,
            2023,
            2024,
            2025,
            2026,
            2027
          ],
          "gen_name": "5th Gen (2019-2027 / DT Body)",
          "trims": [
            "Tradesman",
            "Big Horn / Lone Star",
            "Laramie",
            "Rebel",
            "Limited Longhorn",
            "Limited",
            "TRX",
            "RHO",
            "Tungsten"
          ],
          "cabs": [
            "Quad Cab",
            "Crew Cab"
          ],
          "beds": [
            {
              "name": "5.7 ft Short Bed (67.4 in)",
              "tag": "bed-5-7-ft",
              "wheelbases": [
                "144.5 in (Crew Cab)"
              ]
            },
            {
              "name": "6.4 ft Standard Bed (76.3 in)",
              "tag": "bed-6-4-ft",
              "wheelbases": [
                "140.5 in (Quad Cab)",
                "153.5 in (Crew Cab)"
              ]
            }
          ]
        },
        {
          "years": [
            2009,
            2010,
            2011,
            2012,
            2013,
            2014,
            2015,
            2016,
            2017,
            2018,
            2019,
            2020,
            2021,
            2022,
            2023,
            2024
          ],
          "gen_name": "4th Gen & Classic (2009-2024 / DS Body)",
          "trims": [
            "Tradesman",
            "Express",
            "SLT",
            "Big Horn",
            "Sport",
            "Laramie",
            "Rebel",
            "Limited",
            "Warlock"
          ],
          "cabs": [
            "Regular Cab",
            "Quad Cab",
            "Crew Cab"
          ],
          "beds": [
            {
              "name": "5.7 ft Short Bed (67.4 in)",
              "tag": "bed-5-7-ft",
              "wheelbases": [
                "140.5 in (Crew Cab)"
              ]
            },
            {
              "name": "6.4 ft Standard Bed (76.3 in)",
              "tag": "bed-6-4-ft",
              "wheelbases": [
                "120.5 in (Reg)",
                "140.5 in (Quad)"
              ]
            },
            {
              "name": "8.0 ft Long Bed (98.3 in)",
              "tag": "bed-8-0-ft",
              "wheelbases": [
                "140.5 in (Reg)"
              ]
            }
          ]
        }
      ]
    },
    "2500 / 3500 Heavy Duty": {
      "generations": [
        {
          "years": [
            2019,
            2020,
            2021,
            2022,
            2023,
            2024,
            2025,
            2026,
            2027
          ],
          "gen_name": "Heavy Duty (2019-2027)",
          "trims": [
            "Tradesman",
            "Big Horn",
            "Laramie",
            "Power Wagon",
            "Rebel",
            "Limited Longhorn",
            "Limited"
          ],
          "cabs": [
            "Regular Cab",
            "Crew Cab",
            "Mega Cab"
          ],
          "beds": [
            {
              "name": "6.4 ft Bed (76.3 in)",
              "tag": "bed-6-4-ft",
              "wheelbases": [
                "149.5 in (Crew)",
                "160.5 in (Mega)"
              ]
            },
            {
              "name": "8.0 ft Long Bed (98.3 in)",
              "tag": "bed-8-0-ft",
              "wheelbases": [
                "140.5 in (Reg)",
                "169.5 in (Crew)"
              ]
            }
          ]
        },
        {
          "years": [
            2010,
            2011,
            2012,
            2013,
            2014,
            2015,
            2016,
            2017,
            2018
          ],
          "gen_name": "4th Gen Heavy Duty (2010-2018)",
          "trims": [
            "ST",
            "Tradesman",
            "SLT",
            "Big Horn",
            "Laramie",
            "Power Wagon",
            "Longhorn",
            "Limited"
          ],
          "cabs": [
            "Regular Cab",
            "Crew Cab",
            "Mega Cab"
          ],
          "beds": [
            {
              "name": "6.4 ft Bed (76.3 in)",
              "tag": "bed-6-4-ft",
              "wheelbases": [
                "149.5 in (Crew)",
                "160.5 in (Mega)"
              ]
            },
            {
              "name": "8.0 ft Long Bed (98.3 in)",
              "tag": "bed-8-0-ft",
              "wheelbases": [
                "140.5 in (Reg)",
                "169.5 in (Crew)"
              ]
            }
          ]
        }
      ]
    }
  },
  "Toyota": {
    "Tacoma": {
      "generations": [
        {
          "years": [
            2024,
            2025,
            2026
          ],
          "gen_name": "4th Gen (2024-2026)",
          "trims": [
            "SR",
            "SR5",
            "TRD PreRunner",
            "TRD Sport",
            "TRD Off-Road",
            "Limited",
            "Trailhunter",
            "TRD Pro"
          ],
          "cabs": [
            "XtraCab (Extended)",
            "Double Cab (Crew)"
          ],
          "beds": [
            {
              "name": "5.0 ft Short Bed (60.3 in)",
              "tag": "bed-5-0-ft",
              "wheelbases": [
                "131.9 in (Double Cab)"
              ]
            },
            {
              "name": "6.0 ft Long Bed (73.5 in)",
              "tag": "bed-6-0-ft",
              "wheelbases": [
                "131.9 in (XtraCab)",
                "145.1 in (Double Cab)"
              ]
            }
          ]
        },
        {
          "years": [
            2016,
            2017,
            2018,
            2019,
            2020,
            2021,
            2022,
            2023
          ],
          "gen_name": "3rd Gen (2016-2023)",
          "trims": [
            "SR",
            "SR5",
            "TRD Sport",
            "TRD Off-Road",
            "Limited",
            "TRD Pro",
            "Trail Edition"
          ],
          "cabs": [
            "Access Cab",
            "Double Cab"
          ],
          "beds": [
            {
              "name": "5.0 ft Short Bed (60.5 in)",
              "tag": "bed-5-0-ft",
              "wheelbases": [
                "127.4 in (Double Cab)"
              ]
            },
            {
              "name": "6.0 ft Long Bed (73.7 in)",
              "tag": "bed-6-0-ft",
              "wheelbases": [
                "127.4 in (Access Cab)",
                "140.6 in (Double Cab)"
              ]
            }
          ]
        },
        {
          "years": [
            2005,
            2006,
            2007,
            2008,
            2009,
            2010,
            2011,
            2012,
            2013,
            2014,
            2015
          ],
          "gen_name": "2nd Gen (2005-2015)",
          "trims": [
            "Base",
            "PreRunner",
            "TRD Sport",
            "TRD Off-Road",
            "X-Runner",
            "TRD Pro"
          ],
          "cabs": [
            "Regular Cab",
            "Access Cab",
            "Double Cab"
          ],
          "beds": [
            {
              "name": "5.0 ft Short Bed (Double Cab)",
              "tag": "bed-5-0-ft",
              "wheelbases": [
                "127.4 in"
              ]
            },
            {
              "name": "6.0 ft Bed (Reg/Access/Double)",
              "tag": "bed-6-0-ft",
              "wheelbases": [
                "110.0 in (Reg)",
                "127.4 in (Access)",
                "140.6 in (Double)"
              ]
            }
          ]
        },
        {
          "years": [
            1995,
            1996,
            1997,
            1998,
            1999,
            2000,
            2001,
            2002,
            2003,
            2004
          ],
          "gen_name": "1st Gen (1995-2004)",
          "trims": [
            "Base",
            "DLX",
            "SR5",
            "PreRunner",
            "S-Runner",
            "TRD Off-Road"
          ],
          "cabs": [
            "Regular Cab",
            "Xtracab",
            "Double Cab"
          ],
          "beds": [
            {
              "name": "5.0 ft Bed (Double Cab)",
              "tag": "bed-5-0-ft",
              "wheelbases": [
                "121.9 in"
              ]
            },
            {
              "name": "6.0 ft Bed (Regular/Xtracab)",
              "tag": "bed-6-0-ft",
              "wheelbases": [
                "103.3 in (Reg)",
                "121.9 in (Xtra)"
              ]
            }
          ]
        }
      ]
    },
    "Tundra": {
      "generations": [
        {
          "years": [
            2022,
            2023,
            2024,
            2025,
            2026
          ],
          "gen_name": "3rd Gen (2022-2026 / XK70)",
          "trims": [
            "SR",
            "SR5",
            "Limited",
            "Platinum",
            "1794 Edition",
            "TRD Pro",
            "Capstone"
          ],
          "cabs": [
            "Double Cab",
            "CrewMax"
          ],
          "beds": [
            {
              "name": "5.5 ft Short Bed (65.6 in)",
              "tag": "bed-5-5-ft",
              "wheelbases": [
                "145.7 in (CrewMax)"
              ]
            },
            {
              "name": "6.5 ft Standard Bed (77.6 in)",
              "tag": "bed-6-5-ft",
              "wheelbases": [
                "145.7 in (Double Cab)",
                "157.7 in (CrewMax)"
              ]
            },
            {
              "name": "8.1 ft Long Bed (96.5 in)",
              "tag": "bed-8-1-ft",
              "wheelbases": [
                "164.6 in (Double Cab)"
              ]
            }
          ]
        },
        {
          "years": [
            2007,
            2008,
            2009,
            2010,
            2011,
            2012,
            2013,
            2014,
            2015,
            2016,
            2017,
            2018,
            2019,
            2020,
            2021
          ],
          "gen_name": "2nd Gen (2007-2021 / XK50)",
          "trims": [
            "Base",
            "SR",
            "SR5",
            "Limited",
            "Platinum",
            "1794 Edition",
            "TRD Pro"
          ],
          "cabs": [
            "Regular Cab",
            "Double Cab",
            "CrewMax"
          ],
          "beds": [
            {
              "name": "5.5 ft Short Bed (CrewMax)",
              "tag": "bed-5-5-ft",
              "wheelbases": [
                "145.7 in"
              ]
            },
            {
              "name": "6.5 ft Standard Bed (Regular/Double)",
              "tag": "bed-6-5-ft",
              "wheelbases": [
                "126.8 in (Reg)",
                "145.7 in (Double)"
              ]
            },
            {
              "name": "8.1 ft Long Bed (Regular/Double)",
              "tag": "bed-8-1-ft",
              "wheelbases": [
                "145.7 in (Reg)",
                "164.6 in (Double)"
              ]
            }
          ]
        },
        {
          "years": [
            2000,
            2001,
            2002,
            2003,
            2004,
            2005,
            2006
          ],
          "gen_name": "1st Gen (2000-2006)",
          "trims": [
            "Base",
            "SR5",
            "Limited",
            "Darrell Waltrip"
          ],
          "cabs": [
            "Regular Cab",
            "Access Cab",
            "Double Cab"
          ],
          "beds": [
            {
              "name": "6.2 ft Short Bed (Double Cab)",
              "tag": "bed-6-2-ft",
              "wheelbases": [
                "140.5 in"
              ]
            },
            {
              "name": "6.5 ft Standard Bed (Access Cab)",
              "tag": "bed-6-5-ft",
              "wheelbases": [
                "128.3 in"
              ]
            },
            {
              "name": "8.0 ft Long Bed (Regular Cab)",
              "tag": "bed-8-0-ft",
              "wheelbases": [
                "128.3 in"
              ]
            }
          ]
        }
      ]
    },
    "Land Cruiser (Classic FJ40/FJ60)": {
      "generations": [
        {
          "years": [
            1960,
            1961,
            1962,
            1963,
            1964,
            1965,
            1966,
            1967,
            1968,
            1969,
            1970,
            1971,
            1972,
            1973,
            1974,
            1975,
            1976,
            1977,
            1978,
            1979,
            1980,
            1981,
            1982,
            1983,
            1984,
            1985,
            1986,
            1987,
            1988,
            1989
          ],
          "gen_name": "Classic Land Cruiser (FJ40/FJ60)",
          "trims": [
            "Standard",
            "Deluxe",
            "Troop Carrier"
          ],
          "cabs": [
            "2-Door Hardtop/Soft-top",
            "4-Door Wagon (FJ60)"
          ],
          "beds": [
            {
              "name": "Rear Cargo / Spare Mount",
              "tag": "land-cruiser-cargo",
              "wheelbases": [
                "90.0 in (FJ40)",
                "107.5 in (FJ60)"
              ]
            }
          ]
        }
      ]
    }
  },
  "Jeep": {
    "Gladiator (JT)": {
      "generations": [
        {
          "years": [
            2020,
            2021,
            2022,
            2023,
            2024,
            2025,
            2026
          ],
          "gen_name": "JT Platform (2020-2026)",
          "trims": [
            "Sport",
            "Sport S",
            "Willys",
            "Overland",
            "Rubicon",
            "Mojave",
            "High Altitude",
            "Rubicon X",
            "Mojave X"
          ],
          "cabs": [
            "Crew Cab (4-Door)"
          ],
          "beds": [
            {
              "name": "5.0 ft Bed (60.3 in)",
              "tag": "bed-5-0-ft",
              "wheelbases": [
                "137.3 in"
              ]
            }
          ]
        }
      ]
    },
    "Wrangler (JL / JLU)": {
      "generations": [
        {
          "years": [
            2018,
            2019,
            2020,
            2021,
            2022,
            2023,
            2024,
            2025,
            2026,
            2027
          ],
          "gen_name": "JL Platform (2018-2027)",
          "trims": [
            "Sport",
            "Sport S",
            "Willys",
            "Sahara",
            "Rubicon",
            "Rubicon 392",
            "4xe Hybrid"
          ],
          "cabs": [
            "2-Door",
            "4-Door Unlimited"
          ],
          "beds": [
            {
              "name": "Rear Cargo / Roof Platform",
              "tag": "wrangler-cargo",
              "wheelbases": [
                "96.8 in (2-Door)",
                "118.4 in (4-Door)"
              ]
            }
          ]
        }
      ]
    },
    "Wrangler (JK)": {
      "generations": [
        {
          "years": [
            2007,
            2008,
            2009,
            2010,
            2011,
            2012,
            2013,
            2014,
            2015,
            2016,
            2017,
            2018
          ],
          "gen_name": "JK Platform (2007-2018)",
          "trims": [
            "Sport",
            "Sport S",
            "Sahara",
            "Rubicon",
            "X",
            "Mountain",
            "Call of Duty",
            "Smoky Mountain"
          ],
          "cabs": [
            "2-Door",
            "4-Door Unlimited"
          ],
          "beds": [
            {
              "name": "Rear Cargo / Tailgate",
              "tag": "wrangler-cargo",
              "wheelbases": [
                "95.4 in (2-Door)",
                "116.0 in (4-Door)"
              ]
            }
          ]
        }
      ]
    },
    "Wrangler (TJ)": {
      "generations": [
        {
          "years": [
            1997,
            1998,
            1999,
            2000,
            2001,
            2002,
            2003,
            2004,
            2005,
            2006
          ],
          "gen_name": "TJ Platform (1997-2006)",
          "trims": [
            "SE",
            "Sport",
            "Sahara",
            "Rubicon",
            "Unlimited (LJ)"
          ],
          "cabs": [
            "2-Door Short Wheelbase",
            "2-Door Unlimited (LJ Long Wheelbase)"
          ],
          "beds": [
            {
              "name": "Rear Cargo / Tire Carrier",
              "tag": "wrangler-cargo",
              "wheelbases": [
                "93.4 in (TJ)",
                "103.4 in (LJ)"
              ]
            }
          ]
        }
      ]
    },
    "Wrangler (YJ)": {
      "generations": [
        {
          "years": [
            1987,
            1988,
            1989,
            1990,
            1991,
            1992,
            1993,
            1994,
            1995
          ],
          "gen_name": "YJ Platform Square Headlight (1987-1995)",
          "trims": [
            "Base",
            "Laredo",
            "Sahara",
            "Islander",
            "Renegade",
            "Rio Grande"
          ],
          "cabs": [
            "2-Door Soft Top / Hardtop"
          ],
          "beds": [
            {
              "name": "Rear Cargo / Roll Cage Mount",
              "tag": "wrangler-cargo",
              "wheelbases": [
                "93.4 in"
              ]
            }
          ]
        }
      ]
    },
    "CJ-5 / CJ-7 / Scrambler": {
      "generations": [
        {
          "years": [
            1955,
            1956,
            1957,
            1958,
            1959,
            1960,
            1961,
            1962,
            1963,
            1964,
            1965,
            1966,
            1967,
            1968,
            1969,
            1970,
            1971,
            1972,
            1973,
            1974,
            1975,
            1976,
            1977,
            1978,
            1979,
            1980,
            1981,
            1982,
            1983,
            1984,
            1985,
            1986
          ],
          "gen_name": "Classic CJ Series (1955-1986)",
          "trims": [
            "Renegade",
            "Golden Eagle",
            "Laredo",
            "Custom",
            "CJ-8 Scrambler Pickup"
          ],
          "cabs": [
            "2-Door Open Body / Soft Top",
            "Half-Cab Pickup (Scrambler)"
          ],
          "beds": [
            {
              "name": "Rear Open Tub / Half-Cab Bed",
              "tag": "cj-cargo",
              "wheelbases": [
                "83.5 in (CJ-5)",
                "93.5 in (CJ-7)",
                "103.5 in (CJ-8)"
              ]
            }
          ]
        }
      ]
    },
    "Cherokee (XJ)": {
      "generations": [
        {
          "years": [
            1984,
            1985,
            1986,
            1987,
            1988,
            1989,
            1990,
            1991,
            1992,
            1993,
            1994,
            1995,
            1996,
            1997,
            1998,
            1999,
            2000,
            2001
          ],
          "gen_name": "XJ Platform (1984-2001)",
          "trims": [
            "Base",
            "Pioneer",
            "Laredo",
            "Limited",
            "Sport",
            "Country",
            "Classic"
          ],
          "cabs": [
            "2-Door SUV",
            "4-Door SUV"
          ],
          "beds": [
            {
              "name": "Interior Cargo / Roof Rails",
              "tag": "cherokee-cargo",
              "wheelbases": [
                "101.4 in"
              ]
            }
          ]
        }
      ]
    },
    "Grand Cherokee L": {
      "generations": [
        {
          "years": [
            2021,
            2022,
            2023,
            2024,
            2025,
            2026
          ],
          "gen_name": "WL Platform (2021-2026)",
          "trims": [
            "Laredo",
            "Altitude",
            "Limited",
            "Overland",
            "Summit",
            "Summit Reserve"
          ],
          "cabs": [
            "4-Door SUV (3-Row)"
          ],
          "beds": [
            {
              "name": "Interior Cargo / Flat Tow",
              "tag": "grand-cherokee-cargo",
              "wheelbases": [
                "121.7 in"
              ]
            }
          ]
        }
      ]
    },
    "Grand Wagoneer / Grand Wagoneer L": {
      "generations": [
        {
          "years": [
            2022,
            2023,
            2024,
            2025,
            2026
          ],
          "gen_name": "WS Platform (2022-2026)",
          "trims": [
            "Base",
            "Series II",
            "Carbide",
            "Series III",
            "Obsidian"
          ],
          "cabs": [
            "4-Door Full-Size SUV"
          ],
          "beds": [
            {
              "name": "Interior Cargo / Flat Tow",
              "tag": "grand-wagoneer-cargo",
              "wheelbases": [
                "123.0 in (Standard)",
                "130.0 in (L Long Wheelbase)"
              ]
            }
          ]
        }
      ]
    }
  },
  "Nissan": {
    "Frontier": {
      "generations": [
        {
          "years": [
            2022,
            2023,
            2024,
            2025,
            2026
          ],
          "gen_name": "3rd Gen (2022-2026)",
          "trims": [
            "S",
            "SV",
            "PRO-X",
            "PRO-4X",
            "SL",
            "Hardbody Edition"
          ],
          "cabs": [
            "King Cab (Extended)",
            "Crew Cab (Short & Long)"
          ],
          "beds": [
            {
              "name": "5.0 ft Bed (58.9 in)",
              "tag": "bed-5-0-ft",
              "wheelbases": [
                "126.0 in (Crew Cab)"
              ]
            },
            {
              "name": "6.0 ft Bed (73.3 in)",
              "tag": "bed-6-0-ft",
              "wheelbases": [
                "126.0 in (King Cab)",
                "139.8 in (Crew Cab Long Bed)"
              ]
            }
          ]
        },
        {
          "years": [
            2005,
            2006,
            2007,
            2008,
            2009,
            2010,
            2011,
            2012,
            2013,
            2014,
            2015,
            2016,
            2017,
            2018,
            2019,
            2020,
            2021
          ],
          "gen_name": "2nd Gen (2005-2021 / D40)",
          "trims": [
            "XE",
            "SE",
            "LE",
            "PRO-4X",
            "Desert Runner",
            "SV",
            "SL"
          ],
          "cabs": [
            "King Cab",
            "Crew Cab"
          ],
          "beds": [
            {
              "name": "5.0 ft Bed (Crew Cab)",
              "tag": "bed-5-0-ft",
              "wheelbases": [
                "125.9 in"
              ]
            },
            {
              "name": "6.0 ft Long Bed (King/Crew)",
              "tag": "bed-6-0-ft",
              "wheelbases": [
                "125.9 in (King)",
                "139.9 in (Crew)"
              ]
            }
          ]
        },
        {
          "years": [
            1998,
            1999,
            2000,
            2001,
            2002,
            2003,
            2004
          ],
          "gen_name": "1st Gen (1998-2004 / D22)",
          "trims": [
            "Standard",
            "XE",
            "SE",
            "SC Supercharged"
          ],
          "cabs": [
            "Regular Cab",
            "King Cab",
            "Crew Cab"
          ],
          "beds": [
            {
              "name": "4.6 ft Short Bed (Crew Cab)",
              "tag": "bed-4-6-ft",
              "wheelbases": [
                "116.1 in"
              ]
            },
            {
              "name": "6.0 ft Standard Bed (Reg/King)",
              "tag": "bed-6-0-ft",
              "wheelbases": [
                "104.3 in (Reg)",
                "116.1 in (King)"
              ]
            }
          ]
        }
      ]
    },
    "Titan": {
      "generations": [
        {
          "years": [
            2017,
            2018,
            2019,
            2020,
            2021,
            2022,
            2023,
            2024
          ],
          "gen_name": "2nd Gen (2017-2024)",
          "trims": [
            "S",
            "SV",
            "PRO-4X",
            "Platinum Reserve"
          ],
          "cabs": [
            "King Cab",
            "Crew Cab"
          ],
          "beds": [
            {
              "name": "5.5 ft Bed (Crew Cab)",
              "tag": "bed-5-5-ft",
              "wheelbases": [
                "139.8 in"
              ]
            },
            {
              "name": "6.5 ft Bed (King Cab)",
              "tag": "bed-6-5-ft",
              "wheelbases": [
                "139.8 in"
              ]
            }
          ]
        },
        {
          "years": [
            2004,
            2005,
            2006,
            2007,
            2008,
            2009,
            2010,
            2011,
            2012,
            2013,
            2014,
            2015,
            2016
          ],
          "gen_name": "1st Gen (2004-2015 / A60)",
          "trims": [
            "XE",
            "SE",
            "LE",
            "PRO-4X"
          ],
          "cabs": [
            "King Cab",
            "Crew Cab"
          ],
          "beds": [
            {
              "name": "5.5 ft Short Bed (Crew Cab)",
              "tag": "bed-5-5-ft",
              "wheelbases": [
                "139.8 in"
              ]
            },
            {
              "name": "6.5 ft Standard Bed (King Cab)",
              "tag": "bed-6-5-ft",
              "wheelbases": [
                "139.8 in"
              ]
            },
            {
              "name": "7.0 ft Bed (Crew Cab Long)",
              "tag": "bed-7-0-ft",
              "wheelbases": [
                "159.5 in"
              ]
            },
            {
              "name": "8.0 ft Long Bed (King Cab Long)",
              "tag": "bed-8-0-ft",
              "wheelbases": [
                "159.5 in"
              ]
            }
          ]
        }
      ]
    }
  }
};

  window.TGU_VEHICLE_DATA = VEHICLE_DATA;
})(window);
